import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import vb1 from '@/assets/gallery/vb-1.jpg.asset.json';
import vb2 from '@/assets/gallery/vb-2.jpg.asset.json';
import vb3 from '@/assets/gallery/vb-3.jpg.asset.json';
import vb4 from '@/assets/gallery/vb-4.jpg.asset.json';
import vb5 from '@/assets/gallery/vb-5.jpg.asset.json';
import vb6 from '@/assets/gallery/vb-6.jpg.asset.json';
import vb7 from '@/assets/gallery/vb-7.jpg.asset.json';
import vb8 from '@/assets/gallery/vb-8.jpg.asset.json';
import vb9 from '@/assets/gallery/vb-9.jpg.asset.json';
import vb10 from '@/assets/gallery/vb-10.jpg.asset.json';

export const galleryImages = {
  carb1: { src: vb1.url, alt: 'Restored motorcycle carburettor after vapour blasting' },
  carb2: { src: vb2.url, alt: 'Vintage carburettor body and float bowl restored' },
  gearbox: { src: vb3.url, alt: 'Aluminium gearbox housing finished with vapour blasting' },
  cases: { src: vb4.url, alt: 'Two-stroke engine cases cleaned via vapour blasting' },
  hub: { src: vb5.url, alt: 'Motorcycle hub and brake drum restored' },
  head: { src: vb6.url, alt: 'Motorcycle engine cylinder head and cases' },
  detail: { src: vb7.url, alt: 'Close-up of vapour-blasted aluminium casting detail' },
  mikuni: { src: vb8.url, alt: 'Mikuni carburettor body restored' },
  holley: { src: vb9.url, alt: 'Holley four-barrel carburettor restored' },
  fins: { src: vb10.url, alt: 'Detailed cylinder head fins cleaned by vapour blasting' },
} as const;

interface PhotoStripProps {
  images: { src: string; alt: string }[];
  heading?: string;
  blurb?: string;
}

const PhotoStrip: React.FC<PhotoStripProps> = ({
  images,
  heading = 'Finished examples',
  blurb = 'A few recent jobs from the workshop.',
}) => {
  return (
    <div className="glass-card rounded-xl p-6 md:p-8 my-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
        <div>
          <h2 className="font-display text-2xl font-bold text-foreground">{heading}</h2>
          <p className="text-muted-foreground text-sm mt-1">{blurb}</p>
        </div>
        <Link
          to="/#gallery"
          className="inline-flex items-center gap-2 text-primary hover:text-primary/80 text-sm font-medium uppercase tracking-wider whitespace-nowrap"
        >
          See full gallery <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className={`grid gap-3 ${images.length >= 4 ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-3'}`}>
        {images.map((img) => (
          <Link
            key={img.src}
            to="/#gallery"
            className="group block aspect-square overflow-hidden rounded-lg border border-border bg-black hover:border-primary/60 transition-colors"
            aria-label={`${img.alt} — view in gallery`}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PhotoStrip;
